
export interface archiveItem {
    id: number
    title: string
    createdByDisplayName: any
    createdAt: string
    archivedByDisplayName: any
    archivedAt: string
    contentType: number
    publishedByDisplayName: any
    firstPublishedAt: any
    countOfSubItems: number
    featuredImageUrl: any
    parentListIdPriorToArchiving:number
    parentIsAvailable:boolean
    lastModifiedAt:string
    lastModifiedByDisplayName:string
}

export enum eStatus {
    noItem = "noItem",
    selectedItem = "selectedItem",
    uploading = "uploading"
}

export const TIME_VALUES = [
    'today',
    'last7days',
    'lastmonth',
    'last3months',
    'last6months',
    'lastyear',
    'allTime',
];

export const archiveSortLabels = [
    'Date Archived (Newest First)',
    'Date Archived (Oldest First)',
    'Date Published (Newest First)',
    'Date Published (Oldest First)',
    'Date Modified (Newest First)',
    'Date Modified (Oldest First)',
];

export const contentSortLabels = [
    'All Content',
    'Lists',
    'Pages',
    'RSS',
    'Contacts',
    'Web',
    'File',
    'Audio',
    'Video',
    'Image'
];

export const timeSortLabels = [
   `Today`,
    'Last 7 Days',
    'Past Month',
    'Past 3 Months',
    'Past 6 Months',
    'Past Year',
    'All Time'
];

export const FILTER_OPTIONS = [
    { value: '-1', index: 0 },
    { value: '0', index: 1 },
    { value: '1', index: 2 },
    { value: '2', index: 3 },
    { value: '3', index: 4 },
    { value: '4', index: 5 },
    { value: '6', index: 6 },
    { value: '9', index: 7 },
    { value: '7', index: 8 },
    { value: '5', index: 9 },
];

export interface currApp {
    appId:string, 
    appGuid:string
}